import { getSelectedBubble, nextStep } from 'store/selectedBubble/reducer';
import { Bubble } from 'domain/bubble';
import { useDispatch, useSelector } from 'react-redux';

interface UseBubble {
  currentBubble: Bubble;
  nextBubble: (option: number) => void;
}

export const useBubble = (): UseBubble => {
  const dispatch = useDispatch();

  const currentBubble = useSelector(getSelectedBubble);

  const nextBubble = (option: number) => {
    dispatch(nextStep({ oIdx: option }));
  };

  return { currentBubble, nextBubble };
};
